import React from 'react';
import { Container, Nav, Navbar, Image, Row, Col, NavDropdown } from 'react-bootstrap';
import './MunicipalidadMenu.css';

const MunicipalidadMenu = () => {
  return (
    <Navbar expand="lg" className="bg-body-tertiary">
      <Container className="menu-content">
        <Navbar.Brand href="/">
          <Image src="/assets/images/logo-azul.png" className="logo" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav" className="items">
          <Nav className="me-auto">
            <NavDropdown title="Gobierno" id="basic-nav-dropdown" className="gobierno-dropdow">
              <NavDropdown.Item href="/areas">Áreas</NavDropdown.Item>
              <NavDropdown.Item href="/ejecutivo">Ejecutivo</NavDropdown.Item>
              <NavDropdown.Item href="/concejo-deliverante">Concejo Deliberante</NavDropdown.Item>
              <NavDropdown.Item href="/observatorio-vial">Observatorio Vial</NavDropdown.Item>
              <NavDropdown.Item href="/plan-estrategico">Plan Estratégico</NavDropdown.Item>
              <NavDropdown.Item href="/estados-contables">Estados Contables</NavDropdown.Item>
              <NavDropdown.Item href="/sueldos">Sueldos</NavDropdown.Item>
              <NavDropdown.Item href="/informe-gestion">Informe de Gestión</NavDropdown.Item>
              <NavDropdown.Item href="/datos-abiertos">Datos Abiertos</NavDropdown.Item>
            </NavDropdown>
            <NavDropdown title="Ciudadano" id="basic-nav-dropdown" className="ciudadano-dropdown">
              <NavDropdown.Item
                href="https://autogestion.villalaangostura.gob.ar/ingreso"
                target="_blank"
                rel="noreferrer"
              >
                Autogestión Ciudadana
              </NavDropdown.Item>
              <NavDropdown.Item href="/solicitud-decretos">Solicitud de Decretos</NavDropdown.Item>
              <NavDropdown.Item href="/consulta-ordenanzas">
                Consulta de Ordenanzas
              </NavDropdown.Item>
              <NavDropdown.Item href="/boletines-oficiales">Boletines Oficiales</NavDropdown.Item>
              <NavDropdown.Item href="/seguimiento-vehiculos">
                Seguimiento de Vehículos
              </NavDropdown.Item>
              <NavDropdown.Item
                href="https://autogestion.produccion.gob.ar/consumidores"
                target="_blank"
                rel="noreferrer"
              >
                Reclamos Defensar del Consumidor
              </NavDropdown.Item>
              <NavDropdown.Item
                href="https://defensoriadelpueblovla.ar/"
                target="_blank"
                rel="noreferrer"
              >
                Defensoria del Pueblo
              </NavDropdown.Item>
              <NavDropdown.Item
                href="https://sites.google.com/view/auditoriavillalaangostura/inicio"
                target="_blank"
                rel="noreferrer"
              >
                Auditoría
              </NavDropdown.Item>
              <NavDropdown.Item href="/girsu">GIRSU</NavDropdown.Item>
            </NavDropdown>
            <NavDropdown title="Turismo" id="basic-nav-dropdown" className="turismo-dropdown">
              <NavDropdown.Item
                href="https://www.villalaangosturaturismo.gob.ar/"
                target="_blank"
                rel="noreferrer"
              >
                Descrubrí
              </NavDropdown.Item>
              <NavDropdown.Item
                href="https://www.villalaangosturaturismo.gob.ar/"
                target="_blank"
                rel="noreferrer"
              >
                Organizá
              </NavDropdown.Item>
              <NavDropdown.Item
                href="https://www.villalaangosturaturismo.gob.ar/"
                target="_blank"
                rel="noreferrer"
              >
                Explorá
              </NavDropdown.Item>
              <NavDropdown.Item
                href="https://www.villalaangosturaturismo.gob.ar/"
                target="_blank"
                rel="noreferrer"
              >
                Disfrutá de VLA y sus eventos
              </NavDropdown.Item>
            </NavDropdown>
            <NavDropdown title="Empleados" id="basic-nav-dropdown" className="empleados-dropdown">
              <NavDropdown.Item
                href="https://api.whatsapp.com/send?phone=5492944348430&text="
                target="_blank"
                rel="noreferrer"
              >
                Envío Certificados Médicos
              </NavDropdown.Item>
              <NavDropdown.Item
                href="https://api.whatsapp.com/send?phone=5492944241698&text="
                target="_blank"
                rel="noreferrer"
              >
                Consultas Recursos Humanos
              </NavDropdown.Item>
              <NavDropdown.Item
                href="https://mvla.turecibo.com/e/login"
                target="_blank"
                rel="noreferrer"
              >
                Recibos
              </NavDropdown.Item>
            </NavDropdown>
            <Nav.Link href="#link" className="nav-link-img">
              <Image src="/assets/images/mail.png" />
            </Nav.Link>
            <Nav.Link href="tel:+5492944494155" className="nav-link-img">
              <Image src="/assets/images/telefono.png" />
            </Nav.Link>
            <Nav.Link
              href="https://www.instagram.com/turismovla"
              target="_blank"
              rel="noreferrer"
              className="nav-link-social nav-link-social-first"
            >
              <Image src="/assets/images/ig.png" />
            </Nav.Link>
            <Nav.Link
              href="https://x.com/Turismovla?mx=2"
              target="_blank"
              rel="noreferrer"
              className="nav-link-social"
            >
              <Image src="/assets/images/x.png" />
            </Nav.Link>
            <Nav.Link
              href="https://www.youtube.com/channel/UCme4GRkBsOqZKVoZp1p4kIA"
              target="_blank"
              rel="noreferrer"
              className="nav-link-social"
            >
              <Image src="/assets/images/youtube.png" />
            </Nav.Link>
            <Nav.Link
              href="https://www.tripadvisor.com.ar/Tourism-g312844-Villa_La_Angostura_Province_of_Neuquen_Patagonia-Vacations.html"
              target="_blank"
              rel="noreferrer"
              className="nav-link-social"
            >
              <Image src="/assets/images/tripadvisor.png" />
            </Nav.Link>
            <div className="nav-links-social-mobile">
              <Row>
                <Col>
                  <Image src="/assets/images/mail.png" />
                  <Image src="/assets/images/telefono.png" />
                </Col>
                <Col className="nav-links-social-mobile-social">
                  <a href="https://www.instagram.com/turismovla" target="_blank" rel="noreferrer">
                    <Image src="/assets/images/ig.png" />
                  </a>
                  <a>
                    <Image src="/assets/images/x.png" />
                  </a>
                  <a>
                    <Image src="/assets/images/youtube.png" />
                  </a>
                  <a>
                    <Image src="/assets/images/tripadvisor.png" />
                  </a>
                </Col>
              </Row>
            </div>
            <div className="logo-hide-mobile">
              <Image className="logo-derecha" src="/assets/images/logo.png" />
            </div>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default React.memo(MunicipalidadMenu);
